import { useState, useEffect, useRef } from 'react';
import C from 'classnames';
import * as amazonConnect from 'services/connectService';
import { useCheckRoleAccess } from 'infrastructure/hooks';
import { useAppSelector } from 'store';

import type { TActionFrom } from 'infrastructure/interfaces/common';
import type { FC } from 'react';

interface ConnectProps {
  isOpen: boolean;
  phoneNumber: string;
  patientGuid: string;
  setCallId: (callId: string) => void;
  isRpmCall: boolean;
  deviceId: string;
  readingId: string;
  windowExpanded: boolean;
  actionFrom?: TActionFrom;
  onCallStarted?: (
    callId: string,
    patientGuid: string,
    isRpmCall: boolean,
  ) => void;
  onCallEnded?: () => void;
}

const Connect: FC<ConnectProps> = ({
  isOpen,
  phoneNumber,
  patientGuid,
  setCallId,
  isRpmCall,
  deviceId,
  readingId,
  windowExpanded,
  actionFrom,
  onCallStarted,
  onCallEnded,
}) => {
  const [initialized, setInitialized] = useState(false);
  const socket = useAppSelector((state) => state.socket);
  const awsRum = useAppSelector((state) => state.awsRum);
  const { isReadOnlyRole: isReadOnly } = useCheckRoleAccess();

  const onCallStartedRef = useRef(onCallStarted);
  onCallStartedRef.current = onCallStarted;
  const onCallEndedRef = useRef(onCallEnded);
  onCallEndedRef.current = onCallEnded;

  useEffect(() => {
    if (isOpen && !initialized) {
      amazonConnect.init({
        phoneNumber,
        patientGuid,
        setCallId,
        isRpmCall,
        deviceId,
        readingId,
        wsClient: socket.client!,
        awsRumAgent: awsRum.agent,
        isReadOnlyRole: isReadOnly,
        actionFrom,
        callbacks: {
          onCallStarted: (...args) => onCallStartedRef.current?.(...args),
          onCallEnded: () => onCallEndedRef.current?.(),
        },
      });
      setInitialized(true);
    }

    if (!isOpen && initialized) {
      amazonConnect.terminate();
      setInitialized(false);
    }
  }, [isOpen, phoneNumber]);

  return (
    <div
      className={C('connect', windowExpanded ? 'expanded' : 'collapsed')}
      id="connect-el"
    />
  );
};

export default Connect;
